let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bS9i1")).then(() => parcelRequire('8l63g'));